import { Box } from "@mui/material"
import Logo from "../../shared/Logo"
import { useState, useEffect } from "react"

const Layout = (props) => {
  const { children } = props

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  const Loading = () => (
    <Box
      sx={{
        backgroundColor: "bg.main",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Logo sx={{ width: 184, height: 62 }} />
    </Box>
  )

  if (loading) {
    return <Loading />
  }

  return (
    <Box
      sx={{
        backgroundColor: "bg.main",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "450px",
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Layout
